module.exports = __webpack_public_path__ + "assets/60f4500d9a16d670e67321f65f95665d.mp3";